import Alert from '@material-ui/lab/Alert';
import React from "react";

function Alerts(props) {
    const {severity, body} =props

    return(
        <Alert severity={severity}>{body}</Alert>
    )
}

export default Alerts